<div class="container">
  <h1 id="tour-home-title" class="lg:pb-4 p-2 text-xl">Home</h1>
  <div class="lg:mx-8 p-2">
    <div class="lg:mx-4 ">
      <div class="flex mb-3">
        <h3 class="mr-2 ">Actions</h3>@if (!showActionList) {
        <span (click)="changeViewActionList()"
          class="material-symbols-outlined text-xl align-bottom  self-center text-green-300 cursor-pointer">expand_circle_down</span>
        }@if (showActionList) {
        <span (click)="changeViewActionList()"
          class="material-symbols-outlined text-xl align-bottom  self-center text-green-300 cursor-pointer">expand_circle_up</span>
        }
      </div>
      <div [ngClass]="{'hidden':!showActionList}" class="transition-all ">
        @if (actionList.Actions.length==0 && !actionList.IsError && !actionWaiting) {
        <div>
          <p>All pending actions complete.</p>
        </div>
        }
        @if (actionWaiting) {
        <div>
          <p>Loading...</p>
        </div>
        }
        @if (actionList.IsError) {
        <div>
          <p class="text-danger-base">Unable to load actions at this time, please try again later.</p>
        </div>
        }
        @if (actionList.Actions.length>0) {
        <div>
          @for (action of actionList.Actions; track action) {
            <div>
              <app-compact-action-panel [action]="action" [origin]="'home'" (Refresh)="refreshActionData()"></app-compact-action-panel>
            </div>
          }
        </div>
        }
      </div>

    </div>
  </div>
  <div class="lg:mx-8 p-2">
    @if (auditList.length>0) {
    <div class="lg:mx-4 ">
      <div class="flex mb-3">
        <h3 class="mr-2 ">Current {{ 'audit' | customerTerm:true }}</h3>@if (!showCurrentAudits) {
        <span (click)="changeViewAuditsList()"
          class="material-symbols-outlined text-xl align-bottom  self-center text-green-300 cursor-pointer">expand_circle_down</span>
        }@if (showCurrentAudits) {
        <span (click)="changeViewAuditsList()"
          class="material-symbols-outlined text-xl align-bottom  self-center text-green-300 cursor-pointer">expand_circle_up</span>
        }
      </div>
      @if(showCurrentAudits && auditsReady){
      <div class="transition-all ">
        @for(audit of auditList;track $index){
        <app-incomplete-panel [auditInput]="audit" [linkedAudit]="linkedAudit(audit.AuditGUID,audit.CloudSave)" (Refresh)="refreshAudits()"></app-incomplete-panel>
        }

      </div>
      }

    </div>
    }
  </div>
</div>
